import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/Ui';
import { find } from 'lodash';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
// eslint-disable-next-line import/order
import styles from './styles.scss';
import PromotionPopper from 'containers/PromotionPopper';
import { ArrowRightWhite, ArrowRightBlue } from 'images';

import { translateData } from 'utils/translation';
import { bottleCount } from '../PromotionDetails/constants';
import { selectPromotionLandingPageData } from '../Landing/selectors';
import { selectPromotionId } from '../Cart/selectors';
import * as content from '../PromotionDetails/content';

const PromotionValidation = ({
  buttonLabel,
  buttonColor,
  step,
  promotionApplied,
  onNext,
  cartItems,
  reviewCart,
  showIcon,
  icon,
  discount,
  fullWidth,
  promotionData,
}) => {
  const promoContent =
    content.promoContent.filter(
      (item) => item.name === promotionData.path,
    )[0] || content;

  const translatedBottleType = translateData('PV-Large Bottle');
  const translatedSize = translateData('PV-5-Gallon');
  const translatedEquipmentType = translateData('PV-Equipment');

  const bottle5GItems = cartItems.filter(
    (item) =>
      item.category === translatedBottleType &&
      item.size.includes(translatedSize),
  );
  const bottle5GCount = bottle5GItems.reduce(
    (max, item) => (item.quantity > max ? item.quantity : max),
    0,
  );
  const hasCartDispenser = find(cartItems, {
    category: translatedEquipmentType,
    // count: '1 Dispenser',
  });

  let displayPopper =
    promotionApplied &&
    (bottle5GCount < promoContent.bottleCount ||
      (reviewCart && !(promoContent.dispenserCount === 0 || hasCartDispenser)));

  if (typeof window === 'object' && window.location.pathname.includes('cart')) {
    displayPopper = promotionApplied
      ? !(promotionApplied && discount > 0)
      : false;
  }
  const goNext = step === 1 && !(bottle5GCount < bottleCount);

  const src = buttonColor === 'Blue' ? ArrowRightBlue : ArrowRightWhite;
  const renderIcon = () =>
    showIcon && <img className={styles.imgRight} src={icon || src} alt="" />;

  const renderNext = () => (
    <Button
      text={buttonLabel}
      onClick={onNext}
      disabled={false}
      fullWidth
      icon={renderIcon()}
      iconPosition="right"
      color="dark"
      link={reviewCart}
      href={reviewCart && '/cart'}
    />
  );

  return (
    <div className={styles.buttonContainer}>
      {displayPopper ? (
        <PromotionPopper
          buttonLabel={buttonLabel}
          bottle5GCount={bottle5GCount}
          hasCartDispenser={!!hasCartDispenser}
          viewCart={reviewCart}
          onNext={onNext}
          goNext={goNext}
          fullWidth={fullWidth}
          icon={renderIcon()}
        />
      ) : (
        renderNext()
      )}
    </div>
  );
};

PromotionValidation.defaultProps = {
  buttonLabel: PropTypes.string,
  buttonColor: 'White',
  step: 1,
  promotionApplied: false,
  onNext: () => {},
  cartItems: [],
  reviewCart: false,
  showIcon: false,
  icon: null,
};

const mapStateToProps = createStructuredSelector({
  promotionId: selectPromotionId(),
  promotionData: selectPromotionLandingPageData(),
});

export default connect(mapStateToProps, null)(PromotionValidation);
